<template>
  <DashboardCard :loading="loading">
    <template slot="header">
      {{ $t("adversting.ads_status") }}
    </template>

    <div
      slot="body"
      class="adversting-status"
    >
      <span :style="`color: ${statusColor}`">
        {{ statusText || $t("adversting.default_status") }}
      </span>
      <span v-if="cpaKind === 'REGULAR' && percentOfOrder">
        {{ $t("adversting.percentage_of_order") }}
        <span class="adversting-status__percent">
          {{ `${percentOfOrder}%` }}
        </span>
      </span>
    </div>
  </DashboardCard>
</template>

<script>
export default {
  name: "AdvertisingStatus",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    percentOfOrder: {
      type: Number,
      default: 0
    },
    statusText: {
      type: String,
      default: ""
    },
    statusColor: {
      type: String,
      default: "#262626"
    },
    cpaKind: {
      type: String,
      required: true
    }
  },
  components: {
    DashboardCard: () => import("@/components/Common/DashboardCard")
  }
}
</script>

<style lang="scss">
.extra-content {
  margin-left: auto;
}

.adversting-status {
  display: flex;
  justify-content: space-between;

  &__percent {
    color: #595959;
  }
}
</style>
